exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#form-wizard-tooltip {\n  font-size: 12px; }\n\n.hidden-field {\n  width: 0; }\n\ndiv.mohalla div:nth-child(1) {\n  width: 100%; }\n\ndiv#mohalla div[class^=\"MuiFormControl-root\"] {\n  width: 100% !important; }\n\ndiv#city div[class^=\"MuiFormControl-root\"] {\n  width: 100% !important; }\n\ndiv.assessment-number-of-floors div:nth-child(1) {\n  width: 100%; }\n\ndiv.assessment-number-of-floors div[class^=\"MuiFormControl-root\"] {\n  width: 100% !important; }\n\n@media only screen and (max-width: 768px) {\n  .dummy-field {\n    display: none; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/GenericForm/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/GenericForm/index.css
// module chunks = 504